<po-page-default p-title="Contratos Ativos" p-subtitle="Gerencie os contratos com seus clientes e consulte informações sobre
status, prazos e condições." [p-breadcrumb]="breadcrumb">
  <app-dynamic-table [request]="request" [actions]="actions" [tableColumns]="tableColumns">
    <ng-template #actions>
      <app-export-modal [urlApi]="exportUrlApi" [formFields]="exportFormFields"  />
    </ng-template>
  </app-dynamic-table>
</po-page-default>